module.exports = __webpack_public_path__ + "static/media/Lateral.38fcce28.png";